<template>
  <div class="row">
    <div class="col-lg-4 col-xs-12">
      <button
        class="btn btn-primary full p-2 radius-0 f13"
        @click="edtOrCreate = !edtOrCreate"
      >
        ADICIONAR ETAPA
      </button>
    </div>
    <div class="col-lg-8 col-xs-12">
      <div class="row">
        <div class="col-lg-12 col-xs-12">
          <draggable
            :list="selective_processes"
            :disabled="!can_dragg"
            class="list-group"
            ghost-class="ghost"
            @change="changeProcess"
            v-bind="dragOptions"
          >
            <transition-group type="transition" name="flip-list">
              <div
                v-for="(selective_process, index) in selective_processes"
                :key="selective_process.id"
                class="list-group-item mb-1 mt-1 pointer d-flex full justify-content-between"
              >
                <div>
                  {{ selective_process.name }}
                </div>

                <MenuKanban
                  style="margin-top: -10px !important"
                  :selective_process="selective_process"
                  :index="index"
                  :job_id="job_id"
                  :gallery="gallery"
                  :recruiter_id="recruiter_id"
                  :total_in_column="
                    applies[selective_processes[index].position].length
                  "
                  :questions="questions[selective_processes[index].position]"
                />
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
      <transition name="fade">
        <div class="row mt-1" v-if="edtOrCreate">
          <div class="col-lg-12 col-xs-12 d-flex">
            <input
              type="text"
              class="form-control input-kanbanForm"
              v-model="nameProcess"
            />
            <button
              class="btn f16 color-white bg-primary2 btn-kanbanForm mx-2 radius-0"
              @click="createProcess"
            >
              <i class="fas fa-check"></i>
            </button>
            <button
              class="btn btn-danger color-white f16 radius-0"
              @click="closeForm"
            >
              <i class="far fa-window-close"></i>
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import MenuKanban from "./MenuKanban.vue";
import ComfirmFeedback from "@/Recruiters/Feedback/Confirm.vue";
import draggable from "vuedraggable";
export default {
  props: ["job_id", "recruiter_id", "gallery"],
  components: { draggable, MenuKanban },
  mounted() {
    this.make();
    eventBus.$on("clouseModalEditFeedback", (field) => {
      this.$modal.hideAll();
      this.make();
    });
    eventBus.$on("loadKanbanForm", (field) => {
      this.make();
    });
    eventBus.$on("remove_columnForm", (index) => {
      this.selective_processes.splice(index, 1);
      this.make();
    });
    eventBus.$on("changeNameForm", (field) => {
      this.make();
    });
    this.$root.$on("makeKanbanForm", (field) => {
      this.make();
    });

    eventBus.$on("setDraggable", (value) => {
      this.can_dragg = value;
    });
    this.make();
  },
  data: () => ({
    nameProcess: "",
    edtOrCreate: false,
    showMenu: false,
    can_dragg: true,
    applies: [],
    questions: [],
    total_apply: 0,
    selective_processes: [],
  }),
  watch: {
    selective_processes() {
      this.$root.$emit("columnsChanged", this.selective_processes);
    },
  },
  methods: {
    changeProcess: function (e) {
      axios.put(`/recruiters/jobs/${this.job_id}/kanban/columns`, {
        kanban: { columns: this.selective_processes },
      });
    },
    make() {
      axios
        .get(`/recruiters/jobs/${this.job_id}/kanban.json`)
        .then((response) => {
          this.selective_processes = response.data.selective_processes;
          this.applies = response.data.applies;
          this.questions = response.data.questions;
          this.total_apply = response.data.total_apply;
        });
    },
    closeForm() {
      this.edtOrCreate = false;
      this.nameProcess = "";
    },
    createProcess() {
      axios
        .post(`/recruiters/jobs/${this.job_id}/kanban/columns`, {
          kanban: { column_name: this.nameProcess },
        })
        .then((response) => {
          this.make();
          this.new_column = false;
          this.column_name = "";
        });
      this.make();
      this.edtOrCreate = false;
      this.nameProcess = "";
    },
    changeProcess: function (e) {
      axios.put(`/recruiters/jobs/${this.job_id}/kanban/columns`, {
        kanban: { columns: this.selective_processes },
      });
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>
